import {
  IconAutomatedTrafficFineNotificationStep1,
  IconAutomatedTrafficFineNotificationStep3,
} from '../../../assets/icons'
import { CURRENT_APP_MODE_CONFIG } from '../../../constants/appMode'
import './index.scss'

const AutomatedTrafficFineNotificationStep = ({ step = 0 }) => {
  const StepInfoIcon = CURRENT_APP_MODE_CONFIG.StepInfoIcon
  return (
    <div className="AutomatedTrafficFineNotificationStep">
      <div className={`AutomatedTrafficFineNotificationStep-step ${step === 0 ? 'active-step' : step >= 0 ? 'active-full' : ''}`}>
        <div className="AutomatedTrafficFineNotificationStep-icon">
          <IconAutomatedTrafficFineNotificationStep1 />
        </div>
        <div className="AutomatedTrafficFineNotificationStep-dot">
          <div className="dot"></div>
          <div className="line"></div>
        </div>
        <div className="AutomatedTrafficFineNotificationStep-title">Các gói dịch vụ</div>
      </div>
      <div className={`AutomatedTrafficFineNotificationStep-step active ${step === 1 ? 'active-step' : step >= 1 ? 'active-full' : ''}`}>
        <div className="AutomatedTrafficFineNotificationStep-icon">
          <StepInfoIcon />
        </div>
        <div className="AutomatedTrafficFineNotificationStep-dot">
          <div className="dot"></div>
          <div className="line"></div>
        </div>
        <div className="AutomatedTrafficFineNotificationStep-title">
          {CURRENT_APP_MODE_CONFIG.stepInfoTitle}
        </div>
      </div>
      <div className={`AutomatedTrafficFineNotificationStep-step ${step === 2 ? 'active-step' : step >= 2 ? 'active-full' : ''}`}>
        <div className="AutomatedTrafficFineNotificationStep-icon">
          <IconAutomatedTrafficFineNotificationStep3 />
        </div>
        <div className="AutomatedTrafficFineNotificationStep-dot">
          <div className="dot"></div>
          <div className="line"></div>
        </div>
        <div className="AutomatedTrafficFineNotificationStep-title">Thông tin thanh toán</div>
      </div>
    </div>
  )
}

export default AutomatedTrafficFineNotificationStep
